import React from 'react'

export default function DFSearchInput({ value, onChange, placeholder = 'Search...', variant = 'default', autoFocus = false }) {
  const [focused, setFocused] = React.useState(false)
  const prominent = variant === 'prominent'

  const wrapperStyle = prominent
    ? {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      background: '#ffffff',
      borderRadius: 10,
      padding: '0 14px',
      height: 44,
      boxSizing: 'border-box',
      flex: 1,
      width: '100%',
      border: `1.5px solid ${focused ? 'var(--df-primary, #1f5e3a)' : 'var(--df-line, #e0d8c2)'}`,
      boxShadow: focused
        ? '0 0 0 3px rgba(31, 94, 58, 0.12)'
        : '0 1px 0 rgba(28, 36, 25, 0.02)',
      transition: 'border-color 120ms ease, box-shadow 120ms ease',
    }
    : {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      background: 'var(--df-surface-2)',
      borderRadius: 'var(--df-radius-sm, 6px)',
      padding: '0 10px',
      height: 36,
    }

  const iconSize = prominent ? 16 : 14
  const inputStyle = prominent
    ? {
      flex: 1,
      border: 'none',
      background: 'transparent',
      outline: 'none',
      fontSize: 15,
      fontFamily: 'inherit',
      color: 'var(--df-ink, #1c2419)',
      lineHeight: 1.4,
      fontWeight: 500,
    }
    : {
      flex: 1,
      border: 'none',
      background: 'transparent',
      outline: 'none',
      fontSize: 13,
      fontFamily: 'inherit',
      color: 'var(--df-ink)',
      lineHeight: 1.4,
    }

  return (
    <div style={wrapperStyle}>
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        fill="none"
        stroke={prominent ? 'var(--df-primary, #1f5e3a)' : 'var(--df-ink-4, #97a094)'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0 }}
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={inputStyle}
      />
    </div>
  )
}
